export const idx_data_pin_cog_length = [];

let order = 0;
let i = 0;
let k =0;
idx_data_pin_cog_length.push({
  pap_length: '',
  order_idx: -1,
});

for(let x = 7; x >= 0; x--){
  if(x>0){
    k = x;
} else {
    k = '';
}

if (x < 6) {
  idx_data_pin_cog_length.push({
    pap_length: "-" + k + ' 7/8',
    order_idx: order,
  });
}
order++;

idx_data_pin_cog_length.push({
  pap_length: "-" + k + ' 3/4',
  order_idx: order,
});
order++;

idx_data_pin_cog_length.push({
  pap_length: "-" + k + ' 5/8',
  order_idx: order,
});
order++;

  idx_data_pin_cog_length.push({
    pap_length: "-" + k + ' 1/2',
    order_idx: order,
  });
  order++;


  idx_data_pin_cog_length.push({
    pap_length: "-" + k + ' 3/8',
    order_idx: order,
  });
  order++;

  idx_data_pin_cog_length.push({
    pap_length: "-" + k + ' 1/4',
    order_idx: order,
  });
  order++;

  idx_data_pin_cog_length.push({
    pap_length: "-" + k + ' 1/8',
    order_idx: order,
  });
  order++;

  if (x > 0) {
    idx_data_pin_cog_length.push({
      pap_length: "-" + k + '',
      order_idx: order,
    });
    order++;
  }
}

idx_data_pin_cog_length.push({
  pap_length: '0',
  order_idx: order,
});
order++;

for (let j = 0; j <= 7; j++) {
  if (j > 0) {
    i = j;
  } else {
    i = '';
  }

  if (j > 0) {
    idx_data_pin_cog_length.push({
      pap_length: i + '',
      order_idx: order,
    });
    order++;
  }

  idx_data_pin_cog_length.push({
    pap_length: i + ' 1/8',
    order_idx: order,
  });
  order++;

  idx_data_pin_cog_length.push({
    pap_length: i + ' 1/4',
    order_idx: order,
  });
  order++;

  idx_data_pin_cog_length.push({
    pap_length: i + ' 3/8',
    order_idx: order,
  });
  order++;

  idx_data_pin_cog_length.push({
    pap_length: i + ' 1/2',
    order_idx: order,
  });
  order++;

  idx_data_pin_cog_length.push({
    pap_length: i + ' 5/8',
    order_idx: order,
  });
  order++;

  idx_data_pin_cog_length.push({
    pap_length: i + ' 3/4',
    order_idx: order,
  });
  order++;

  if (j < 6) {
    idx_data_pin_cog_length.push({
      pap_length: i + ' 7/8',
      order_idx: order,
    });
  }
  order++;

}
